import { render, staticRenderFns } from "./mainBodyGoodsTabs.vue?vue&type=template&id=742c7cd3&scoped=true&"
import script from "./mainBodyGoodsTabs.vue?vue&type=script&lang=js&"
export * from "./mainBodyGoodsTabs.vue?vue&type=script&lang=js&"
import style0 from "./mainBodyGoodsTabs.vue?vue&type=style&index=0&id=742c7cd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c7cd3",
  null
  
)

export default component.exports